import { motion } from "framer-motion";

const PAUSE_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/g2bmnhrq_All%20Machines%20Together.png";

export const PhotographicPause = () => (
  <section data-testid="photographic-pause-section" className="bg-baseLight px-4 py-[30px] sm:px-6 sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="relative lg:max-w-[1280px] lg:mx-auto rounded-[27px] overflow-hidden h-[340px] sm:h-[440px] lg:h-[530px]">
      <img
        src={PAUSE_IMAGE}
        alt="Solar panels, wind turbine, battery storage and hydrogen equipment in a mountain setting"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/55 via-ink/5 to-transparent" />
      <div className="absolute bottom-10 sm:bottom-14 left-6 sm:left-12 lg:left-16">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.7 }}
          data-testid="pause-headline"
          className="font-heading text-[30px] sm:text-[35px] lg:text-[41px] font-semibold text-white leading-tight max-w-lg"
        >
          Power doesn't stop when conditions change
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="text-white/75 text-base sm:text-lg mt-3"
        >
          Neither should your operation.
        </motion.p>
      </div>
    </div>
  </section>
);
